if (!customElements.get('collection-featured-grid')) {
  customElements.define('collection-featured-grid', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('ul');
      this.featured = this.grid?.querySelector('[data-collection-featured]');
      if (!this.featured) return;

      this.desktop = window.matchMedia('(min-width: 990px)');
      this.place = () => {
        const offset = this.desktop.matches ? (Number(this.dataset.columnsDesktop) || 2) * 2 : 4;
        const products = [...this.grid.children].filter(item => item !== this.featured);
        const next = products[offset] || null;
        if (this.featured.nextElementSibling !== next) {
          this.grid.insertBefore(this.featured, next);
        }
      };
      this.desktop.addEventListener('change', this.place);
      this.place();
    }

    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.place);
    }
  });
}
